import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const isDev = typeof process !== "undefined" && process.env.NODE_ENV === "development";

export default function Login() {
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  const handleDevLogin = () => {
    const value = token.trim();
    if (!value) return;
    navigate(`/auth/consume?token=${encodeURIComponent(value)}`);
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Login</h1>
      <p>Bitte nutze deinen Einladungslink.</p>
      {isDev && (
        <div>
          <label htmlFor="dev-token">Token (DEV)</label>
          <input
            id="dev-token"
            type="text"
            value={token}
            onChange={(event) => setToken(event.target.value)}
            style={{ display: "block", marginTop: "0.5rem", maxWidth: "320px" }}
          />
          <button type="button" onClick={handleDevLogin} style={{ marginTop: "0.5rem" }}>
            Anmelden
          </button>
        </div>
      )}
    </div>
  );
}
